export const SET_MAP_MODE = "SET_MAP_MODE";

export interface SetMapModeAction {
  type: typeof SET_MAP_MODE;
  payload: boolean;
}

export type MapModeActionTypes = SetMapModeAction;

export const setMapMode = (isMapMode: boolean): SetMapModeAction => ({
  type: SET_MAP_MODE,
  payload: isMapMode,
}); 